
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { MARKETING_MATURE } from '@src/view/components/viewer/data';
import { TopcoPartner } from '@src/lib/marketing/TopcoPartner';
import { UserDefault } from '@src/lib';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { isRefererCheck } from '@src/lib/utils/utils';
import React, { useEffect } from 'react';
import {
  getComicData,
  getFirstEpisode,
  getViewSignedCookies,
} from '@src/server/comicData';
import Seo, { GoogleSearchData } from '@src/seo/Seo';
import { CompanyInfo } from '@src/constants';

const Episode = dynamic<any>(
  () =>
    import('@src/view/components/episode').then(
      (mod: any) => mod.EpisodeComponent,
    ),
  {
    ssr: false,
  },
);

const Index = (props: any) => {
  const { comic, data, isReferer } = props;

  return (
    <>
      <Seo
        title={`${data.title} ｜ ${CompanyInfo.NAME_UPPER_CASE} - Daily Updated Popular Web comics`}
        description={data.description}
        canonical={`${process.env.REACT_APP_PUBLIC_URL}/content/${comic}`}
        searchData={GoogleSearchData({
          title: data.title,
          url: `${process.env.REACT_APP_PUBLIC_URL}/content/${comic}`,
          description: data.description,
          image: data.thumbnail17,
          author: data.author,
        })}
        image={data.thumbnail17}
      />
      <Episode
        marketingMature={MARKETING_MATURE.UNSET}
        comicId={comic}
        isReferer={isReferer}
        comicTitle={data.title}
        thumbnail17={data.thumbnail17}
      />
    </>
  );
};

 async function _getServerSideProps(context: any) {
  const { query } = context;

  const ret = await TopcoPartner.setterSSR(context);
  if (ret) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  const { comicId } = query;
  const isReferer = isRefererCheck(context);

  let comic: number = 0;

  if (comicId && !_.isNaN(Number(comicId))) {
    comic = Number(comicId);
  }

  if (comic === 0) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  try {
    const data = await getComicData(Number(comic));

    // 영상 작품(comicType === 3) 최초 진입 시 1화 서명쿠키 발급 (배너 프리뷰 재생용)
    if (Number(data.comicType) === 3) {
      const firstEpisode = await getFirstEpisode(comic);
      // 1화가 순수 무료(coin === 0)일 때만 서명쿠키 발급
      if (firstEpisode && firstEpisode.coin === 0) {
        const viewSigned = await getViewSignedCookies({
          comicId: comic,
          episodeId: firstEpisode.episodeId,
        });
        if (viewSigned !== null && viewSigned?.data?.signedCookies) {
          context.res.setHeader('Set-Cookie', [
            `CloudFront-Key-Pair-Id=${viewSigned?.data?.signedCookies['CloudFront-Key-Pair-Id']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
            `CloudFront-Policy=${viewSigned?.data?.signedCookies['CloudFront-Policy']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
            `CloudFront-Signature=${viewSigned?.data?.signedCookies['CloudFront-Signature']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
          ]);
        }
      }
    }

    return {
      props: {
        isReferer,
        data,
        comic,
      },
    };
  } catch (err: any) {
    console.error(err);
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }
}

export default Index;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/content/[comicId]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  